import * as Phaser from 'phaser';
import { LoadingScene } from './scenes/LoadingScene';
import { GameScene } from './scenes/GameScene';
import { CollectionScene } from './scenes/CollectionScene';
import { SettingsScene } from './scenes/SettingsScene';
import { LegendaryRevealScene } from './scenes/LegendaryRevealScene';
import { AnalyticsDashboardScene } from './scenes/AnalyticsDashboardScene';
import { DebugPanelScene } from './scenes/DebugPanelScene';
import { TitleScene } from './scenes/TitleScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: 1280,
  height: 720,
  backgroundColor: '#f8f9ff',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [TitleScene, LoadingScene, GameScene, CollectionScene, SettingsScene, LegendaryRevealScene, AnalyticsDashboardScene, DebugPanelScene],
};

new Phaser.Game(config);
